import { render, staticRenderFns } from "./TransactionInventorySummary.vue?vue&type=template&id=2871627f"
import script from "./TransactionInventorySummary.vue?vue&type=script&lang=js"
export * from "./TransactionInventorySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports